module.exports = __webpack_public_path__ + "media/errors/404-744c594e.png";